package one.devsbox.www.ui.resources

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.graphics.Color
import one.devsbox.www.provider.*
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.LocalNavigationArgs
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.viewModel

class ListingResourcesCtx private constructor(
    val vm: ListingResourcesVM,
    val nav: Navigation,
    val args: ArgsListingResource,
    val navCallback: NavigationCallbackProvider,
    val pickerTask: NavigationCallbackProvider.Task.Media?,
    val me: MeProvider,
    val colorPrimaryContainer: Color,
    val colorSecondaryContainer: Color
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): ListingResourcesCtx {
            val nav = LocalNavigation.current
            val args = LocalNavigationArgs.current.args(ArgsListingResource::class)
            val navCallback = LocalNavigationCallbackProvider.current
            val me = LocalMeProvider.current
            val vm = nav.viewModel(ListingResourcesVM::class)
            val colorPrimary = MaterialTheme.colorScheme.primary
            val colorSecondary = MaterialTheme.colorScheme.secondary
            return remember {
                ListingResourcesCtx(
                    vm = vm,
                    nav = nav,
                    args = args,
                    navCallback = navCallback,
                    pickerTask = navCallback.publisher[args.pickerModeKey],
                    me = me,
                    colorPrimaryContainer = colorPrimary,
                    colorSecondaryContainer = colorSecondary
                ).apply {
                    vm.setup(this)
                }
            }
        }
    }
}

